import { createContext, useState } from "react";
import * as THREE from "three";
import HotSpotInsctance from "../component/HotspotInstance";

const ModelContext = createContext();

const ModelProvider = ({ children }) => {
  const [animations, setAnimations] = useState([]);
  const [activetedAnimations, setActivetedAnimations] = useState([]);
  const [showSpot, setShowSpot] = useState(true);
  const [direction, setDirection] = useState("0m 0m 1m");

  const [animationName, setAnimationName] = useState("");
  const [animationType, setAnimationType] = useState();
  const [annotationType, setAnnotationType] = useState();
  const [position, setPosition] = useState();
  const [normal, setNormal] = useState();

  const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  const [camera] = useState(
    new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 100)
  );

  const [renderer] = useState(
    new THREE.WebGLRenderer({
      alpha: true,
      antialias: true,
    })
  );

  const handleUsdz = async () => {
    const modelViewer = document.getElementById("modelViewer");
    modelViewer.downloadUsdz();
  };

  const getPoints = () => {
    document
      .getElementById("modelViewer")
      .removeEventListener("click", getPoints);
    const { position, normal } = HotSpotInsctance.points();
    //setPosition(position);
    //setNormal(normal);

    return { position, normal };
  };

  const drawHotSpot = () => {
    const { position, normal } = getPoints();
    setPosition(position);
    setNormal(normal);
    const data = {
      type: annotationType ? annotationType : 0,
      position: position,
      direction: normal,
      animationName: animationName,
      animationType: animationType ? animationType : 2,
    };
    drawHotSpotFromData(data);
  };

  const drawHotSpotFromData = (data) => {
    let element = document.getElementById("modelViewer");
    let annoElement = element.hotspotConroller.createHotspotElement(data);
    element.appendChild(annoElement);
    HotSpotInsctance.booly = false;
    setShowSpot(false);
    return annoElement;
  };

  const values = {
    renderer,
    setAnimationType,
    animationName,
    camera,
    animationType,
    setAnimationName,
    annotationType,
    setAnnotationType,
    position,
    setPosition,
    handleUsdz,
    getPoints,
    direction,
    setDirection,
    drawHotSpot,
    drawHotSpotFromData,
    animations,
    setAnimations,
    setShowSpot,
    activetedAnimations,
    setActivetedAnimations,
    normal,
  };

  return (
    <ModelContext.Provider value={values}>{children}</ModelContext.Provider>
  );
};

export { ModelContext, ModelProvider };
